import styled from 'styled-components';

const StyledPanelContent = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
	align-items: stretch;
	border-radius: 0 0 10px 10px;
	background-color: rgba(0, 0, 0, 0.9);
`;

export { StyledPanelContent };
